import React from "react";
import { Image, Form } from "react-bootstrap";
import { getVisiblePageNumbers } from "utils/paginationUtils";

const TablePagination = ({
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions = [5, 10, 20, 50],
  onPageChange,
  onPageSizeChange,
}) => {
  const visiblePages = getVisiblePageNumbers(currentPage, totalPages);

  return (
    <div className="table-pagination d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div className="table-pagination__controls d-flex align-items-center flex-wrap">
        <button
          type="button"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="previous-btn-dataTable me-2 d-flex align-items-center"
        >
          <Image
            src="/assets/images/arrow-previous.svg"
            width={14}
            className="me-2"
            alt=""
          />
          Previous
        </button>

        {visiblePages.map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="table-pagination__ellipsis mx-1">
              …
            </span>
          ) : (
            <button
              key={page}
              type="button"
              className={
                page === currentPage
                  ? "previous-btn-dataTable-active mx-1"
                  : "previous-btn-dataTable mx-1"
              }
              onClick={() => onPageChange(page)}
              aria-current={page === currentPage ? "page" : undefined}
            >
              {page}
            </button>
          )
        )}

        <button
          type="button"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => onPageChange(currentPage + 1)}
          className="previous-btn-dataTable ms-2 d-flex align-items-center"
        >
          Next
          <Image
            src="/assets/images/arrow-next.svg"
            width={14}
            className="ms-2"
            alt=""
          />
        </button>
      </div>

      {typeof onPageSizeChange === "function" && (
        <Form.Select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="table-pagination__size-select"
          aria-label="Rows per page"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Form.Select>
      )}
    </div>
  );
};

export default TablePagination;
